import { Component, OnInit, ChangeDetectionStrategy, OnChanges, Input } from '@angular/core';

@Component({
    selector: 'app-footer-abstrac-class',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterAbstracClassComponent implements OnInit, OnChanges {
    @Input({ required: true }) isDesktop!: boolean;

    showMenuContent = false;

    ngOnInit(): void {
        if (this.isDesktop) {
            this.showMenuContent = true;
        }
    }

    ngOnChanges(): void {
        if (!this.isDesktop) {
            this.showMenuContent = false;
        } else {
            this.showMenuContent = true;
        }
    }

    toggleMenu(): void {
        if (!this.isDesktop) {
            this.showMenuContent = !this.showMenuContent;
        }
    }
}
